import { useState } from 'react'
import { Star } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { clsx } from 'clsx'
import { WATCHLIST_LIMIT, useWatchlist } from '@/store/watchlist'

/** Star toggle for the local watchlist; explains the limit instead of failing silently. */
export function WatchButton({ id, className }: { id: string; className?: string }) {
  const { t } = useTranslation()
  const watched = useWatchlist((s) => s.ids.includes(id))
  const toggle = useWatchlist((s) => s.toggle)
  const [full, setFull] = useState(false)
  const label = full
    ? t('watch.full', { n: WATCHLIST_LIMIT })
    : watched
      ? t('watch.remove')
      : t('watch.add')
  return (
    <button
      type="button"
      aria-pressed={watched}
      aria-label={label}
      title={label}
      onClick={() => {
        const result = toggle(id)
        setFull(result === 'full')
        if (result === 'full') setTimeout(() => setFull(false), 2500)
      }}
      className={clsx(
        'relative inline-flex size-9 shrink-0 items-center justify-center rounded-xl transition hover:bg-surface-3',
        watched ? 'text-gold-400' : 'text-subtle hover:text-fg',
        full && 'animate-[gx-shake_300ms] text-warn',
        className,
      )}
    >
      <Star className="size-[1.05rem]" fill={watched ? 'currentColor' : 'none'} />
      <span role="status" aria-live="polite" className="sr-only">
        {full ? label : ''}
      </span>
    </button>
  )
}
